import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// template icon imports
import Linkedin from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/social/Linkedin';

export const LinkStyledBio = styled(Link)`
  padding-bottom: ${rem(24)};
`;

export const LinkedinStyledSocialIcon = styled(Linkedin)`
  ${({ theme }) => {
    return css`
      .icon-fill {
        fill: ${theme.colors.blue.blueLight20};
      }
    `;
  }}
`;

